import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import BasicObject from 'model/basicObject'

class BenefitTier extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> BenefitTier constructor -', init)
    if (isNil(init)) return undefined
    this._color = init.color
    this._default_state = init.default_state
    this._national_bluecard = init.national_bluecard
    this._kind = init.kind
    this._name = init.name
    this._position = init.position
    this._uuid = init.uuid
  }

  static shape = {
    color: PropTypes.string,
    default_state: PropTypes.bool,
    national_bluecard: PropTypes.bool,
    // kind: PropTypes.bool,
    name: PropTypes.string,
    position: PropTypes.number,
    uuid: PropTypes.string
  }

  get color() {
    return this._color
  }

  get default_state() {
    return this._default_state
  }

  get national_bluecard() {
    return this._national_bluecard
  }

  get kind() {
    return this._kind
  }

  get name() {
    return this._name
  }

  get position() {
    return this._position
  }

  get uuid() {
    return this._uuid
  }
}

export default BenefitTier
